import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Executes one API request for every dispatched load request. */
export const executeLoad = store.effects.create(
  <TTypeParams extends Plugin.TypeParams>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.load.request.observe().pipe(
      rxjs.mergeMap(action =>
        plugin.api.getOptions(action.data).pipe(
          rxjs.takeUntil(
            feature.actions.loadOptions
              .observe()
              .pipe(
                rxjs.filter(
                  ({ data }) =>
                    data === undefined ||
                    data.criteria.entityId === action.data.criteria.entityId,
                ),
              ),
          ),
          rxjs.map(response =>
            feature.actions.load.success.from(action).create({
              request: action.data,
              response,
            }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.load.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
